import { render, staticRenderFns } from "./SliderSetting.vue?vue&type=template&id=3512ffb4&scoped=true&"
import script from "./SliderSetting.vue?vue&type=script&lang=js&"
export * from "./SliderSetting.vue?vue&type=script&lang=js&"
import style0 from "./SliderSetting.vue?vue&type=style&index=0&id=3512ffb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3512ffb4",
  null
  
)

export default component.exports